import * as React from "react";
import { Card } from "antd";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { CardContent } from "../../../components/antd/card/CardContent";
import { CpInputDescription } from "../testNewForm/CpInputDescription";
import { CpFormItem } from "../testNewForm/CpFormItem";
import { CpLabel } from "../testNewForm/CpLabel";
import { CpErrorWarning } from "../testNewForm/CpErrorWarning";
import { CpInput } from "../testNewForm/CpInput";
import { CpErrorWarningArrayIcon } from "../testNewForm/CpErrorWarningArrayIcon";
import { CpLabelTooltip } from "../testNewForm/CpLabelTooltip";
import { CpTooltip } from "../testNewForm/CpTooltip";

export const General: React.FC = () => {
  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>
            GVC
            <CpErrorWarningArrayIcon names={["name", "description"]} />
          </CardTitle>
          <CardContent>
            <CpFormItem>
              <CpLabelTooltip>
                <CpLabel name={"name"}>Name</CpLabel>
                <CpTooltip tooltipProps={{ title: "Cannot be changed after creation (ok, my-item, item1)" }} />
              </CpLabelTooltip>
              <CpInput name={"name"} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={"name"} />
            </CpFormItem>
            <CpInputDescription namePath="name" descriptionPath="description" />
          </CardContent>
        </Card>
      </div>
    </>
  );
};
